import { router } from "@/app/routes";
import { TanstackQueryDevtools } from "@/shared/components/utils/tanstack-query-devtools.tsx";
import { useGlobalErrorHandler, useVersionCheck } from "@/shared/hooks";
import { TanstackDevToolsInProductionContext } from "@/shared/hooks/use-tanstack-devtools-production.ts";
import { initLogging } from "@/shared/utils/datadog-logger.ts";
import "@/styles/index.css";
import "@tractie/components";
import { useState } from "react";
import { RouterProvider } from "react-router";

initLogging();

export default function App() {
    const devToolsState = useState(import.meta.env.MODE === "development");
    // Catch global errors that ErrorBoundary misses
    useGlobalErrorHandler();
    // polling to check if current version is the most recently deployed version
    useVersionCheck();

    return (
        <TanstackDevToolsInProductionContext value={devToolsState}>
            <RouterProvider router={router} />
            <TanstackQueryDevtools />
        </TanstackDevToolsInProductionContext>
    );
}
